"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Send = _interopRequireDefault(require("@material-ui/icons/Send"));

var Yup = _interopRequireWildcard(require("yup"));

var _formik = require("formik");

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var _reactRedux = require("react-redux");

var _autoSubmit = _interopRequireDefault(require("../../../../_common/textfields/autoSubmit"));

var _dialog = _interopRequireDefault(require("../../../../_common/dialog"));

var _phoneNumber = _interopRequireDefault(require("../../../../_common/textfields/phoneNumber"));

var _fullScreen = _interopRequireDefault(require("../../../../_common/dialog/fullScreen"));

var _actions = require("../../../../../redux/locations/actions");

var _selectors = require("../../../../../redux/locations/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var EmailDialog = function EmailDialog(_ref) {
  var open = _ref.open,
      location = _ref.location,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      recaptcha = _useState2[0],
      setRecaptcha = _useState2[1];

  var recaptchaRef = (0, _react.useRef)(null);

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      lastPageViewId = _useSearchSelector.lastPageViewId;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useFormik = (0, _formik.useFormik)({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: ""
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Please enter a value"),
      email: Yup.string().email().required("Please enter a valid email"),
      phone: Yup.string().required("Please enter a value"),
      subject: Yup.string().required("Please enter a value"),
      message: Yup.string().required("Please enter a message")
    }),
    onSubmit: function onSubmit(values) {
      dispatch((0, _actions.contactLocation)(values.name, values.email, values.phone, values.subject, values.message, location.id));
      dispatch((0, _actions.trackLocationClick)(location.id, "contact_emails", lastPageViewId));
      resetForm();
      onClose();
    }
  }),
      handleSubmit = _useFormik.handleSubmit,
      values = _useFormik.values,
      handleChange = _useFormik.handleChange,
      errors = _useFormik.errors,
      touched = _useFormik.touched,
      resetForm = _useFormik.resetForm;

  var contactActions = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight15"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "default",
    onClick: onClose
  }, "Cancel")), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "primary",
    onClick: handleSubmit,
    disabled: !Boolean(recaptcha)
  }, /*#__PURE__*/_react.default.createElement(_Send.default, null), "\xA0\xA0Send"));

  var form = /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: handleSubmit,
    className: "email-dialog-form"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_autoSubmit.default, {
    name: "name",
    label: "Your Name",
    value: values.name,
    placeholder: "John Doe",
    onChange: handleChange,
    onSubmit: handleSubmit,
    fullWidth: true,
    error: touched.name && errors.name,
    helperText: touched.name && errors.name ? errors.name : null,
    inputProps: {
      maxLength: 200
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_autoSubmit.default, {
    name: "email",
    label: "Your Email",
    value: values.email,
    placeholder: "example@google.com",
    onChange: handleChange,
    onSubmit: handleSubmit,
    fullWidth: true,
    error: touched.email && errors.email,
    helperText: touched.email && errors.email ? errors.email : null,
    inputProps: {
      maxLength: 250
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_phoneNumber.default, {
    name: "phone",
    label: "Phone Number",
    type: "phone",
    value: values.phone,
    placeholder: "(555) 555-5555",
    onChange: handleChange,
    onSubmit: handleSubmit,
    fullWidth: true,
    error: touched.phone && errors.phone,
    helperText: touched.phone && errors.phone ? errors.phone : null,
    inputProps: {
      maxLength: 14
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_autoSubmit.default, {
    name: "subject",
    label: "Subject",
    value: values.subject,
    placeholder: "Interested in a visit...",
    onChange: handleChange,
    onSubmit: handleSubmit,
    fullWidth: true,
    error: touched.subject && errors.subject,
    helperText: touched.subject && errors.subject ? errors.subject : null,
    inputProps: {
      maxLength: 200
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_autoSubmit.default, {
    name: "message",
    label: "Message",
    value: values.message,
    placeholder: "Message here...",
    onChange: handleChange,
    onSubmit: handleSubmit,
    fullWidth: true,
    error: touched.message && errors.message,
    helperText: touched.message && errors.message ? errors.message : null,
    inputProps: {
      maxLength: 1000
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop30"
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: recaptchaRef,
    sitekey: "6LfNdhsUAAAAAHxU9LqOu2w-ZW5UXmF32Wj37UYh",
    onChange: function onChange(event) {
      return setRecaptcha(event);
    }
  })));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: open,
    title: "Contact ".concat(location.name),
    onClose: onClose,
    actions: contactActions
  }, form)), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    open: open,
    title: "Contact ".concat(location.name),
    onClose: onClose,
    actions: contactActions
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, "Contact ", location.name)), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "20px"
    }
  }, form, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, contactActions))))));
};

var _default = EmailDialog;
exports.default = _default;